export class RaceAdditionalPricingItem {
  constructor(public id?: number,
              public raceId?: number,
              public name?: string,
              public nameEng?: string,
              public nameIta?: string,
              public nameSlo?: string,
              public internalDescription?: string,
              public additionalTextField?: string,
              public priceConstant?: boolean,
              public fieldRequiredForRegistration?: boolean,
              public fieldVisibility?: number,
              public fieldRegistrationDisplayFlag?: number,
              public vat?: number,
              public vatExplanation?: string,
              public vatExplanationEng?: string,
              public vatExplanationSlo?: string,
              public vatExplanationIta?: string,
              public price?: number,
              public priceWithDiscount?: number,
              public multipleSelectionAllowed?: boolean,
              public pricingItemValues?: RacePricingItemValue[]) {
  }
}

export class RacePricingItemValue {
  constructor(
    public id?: number,
    public itemId?: number,
    public name?: string,
    public nameEng?: string,
    public nameIta?: string,
    public nameSlo?: string,
    public price?: number,
    public priceWithDiscount?: number
  ) {
  }
}
